
import { ColorButton } from '@naker/design/Pickers/colorPicker';
import { Button } from '@naker/design/Inputs/button';
import { InputGroupSwitch } from '@naker/design/Layers/actionPanel';

import { BackUndo } from './service/undo';
import { Environment, environmentInterface } from '../viewer/environment';
import { Particle, particleInterface } from '../viewer/particle';

import { RadioIconInput } from '@naker/design/Inputs/radio';

/*
  +------------------------------------------------------------------------+
  | COLOR SETTINGS                                                         |
  +------------------------------------------------------------------------+
*/

export class colorSettingsClass extends InputGroupSwitch {

    environment: Environment
    particle: Particle

    colorEnd: HTMLElement;
    colorStart: HTMLElement;
    colorPalette: HTMLElement;

    constructor(undo:BackUndo, environment: Environment, particle: Particle) {
        super('Colors', undo);

        this.environment = environment;
        this.particle = particle;

        this.addInputs();
        this.checkInput(environment.getOptions(), particle.getOptions());

        undo.on("change", (change) => {
            if (change.particle) this.checkParticleInput(change.particle);
            if (change.environment) this.checkEnvironmentInput(change.environment);
        });
    }

    gradientInput: RadioIconInput;
    backgroundStartInput: ColorButton;
    backgroundEndInput: ColorButton;
    // vignetteColorInput:ColorButton;
    particleStartInput: ColorButton;
    particleEndInput: ColorButton;
    paletteButton: Button;

    addInputs() {
        this.gradientInput = this.addRadioIcon('Gradient', { value: 'vertical', list: ['vertical', 'horizontal', 'radial'], iconLink: { 'vertical': 'vertical', 'horizontal':'horizontal', 'radial':'point'}, tooltip: false }, (value) => {
            this.environment.setSkyGradient(value);
        });
        this.backgroundStartInput = this.addColorInput('Background start', { opacity: true, removable: false }, (rgba) => {
            this.environment.setBackStart(rgba);
        });
        this.backgroundEndInput = this.addColorInput('Background end', { opacity: true, removable: false }, (rgba) => {
            this.environment.setBackStop(rgba);
        });
        this.particleStartInput = this.addColorInput('Particle start', { opacity: true, removable: false }, (rgba) => {
            this.particle.setColorStart(rgba);
        });
        this.particleEndInput = this.addColorInput('Particle end', { opacity: true, removable: false }, (rgba) => {
            this.particle.setColorEnd(rgba);
        });
        // this.vignetteColorInput = this.addColorInput('Vignette', {opacity:true, removable:false}, (rgba) => {
        //   this.environment.setVignetteColor(rgba);
        // });
        // this.paletteButton = this.addButton({ui:'icon', text:'collapse'}, 'collapse-button', () => {
        //   this.checkColorPalette();
        // });
    }
    
    resetInput(environmentOptions: environmentInterface, particleOptions: particleInterface) {
        this.gradientInput.setValue(environmentOptions.gradient);
        this.backgroundStartInput.setValue(environmentOptions.colorStart);
        this.backgroundEndInput.setValue(environmentOptions.colorEnd);
        // this.vignetteColorInput.setValue(environmentOptions.vignetteColor);
        this.particleStartInput.setValue(particleOptions.colorStart);
        this.particleEndInput.setValue(particleOptions.colorEnd);
    }
    
    checkInput(environmentOptions: environmentInterface, particleOptions: particleInterface) {
        this.checkEnvironmentInput(environmentOptions);
        this.checkParticleInput(particleOptions);
    }

    checkEnvironmentInput(environmentOptions: environmentInterface) {
        if (environmentOptions.gradient !== undefined) this.gradientInput.setValue(environmentOptions.gradient);
        if (environmentOptions.colorStart !== undefined) this.backgroundStartInput.setValue(environmentOptions.colorStart);
        if (environmentOptions.colorEnd !== undefined) this.backgroundEndInput.setValue(environmentOptions.colorEnd);
        // if (environmentOptions.vignetteColor !== undefined) this.vignetteColorInput.setValue(environmentOptions.vignetteColor);
    }

    checkParticleInput(particleOptions: particleInterface) {
        if (particleOptions.colorStart !== undefined) this.particleStartInput.setValue(particleOptions.colorStart);
        if (particleOptions.colorEnd !== undefined) this.particleEndInput.setValue(particleOptions.colorEnd);
    }

    // paletteList: Array < paletteInterface > = [
    //     { colorStart: [100, 0, 0], colorEnd: [0, 50, 100], colorStart: [50, 0, 50], colorEnd: [130, 0, 240] },
    //     { colorStart: [200, 0, 0], colorEnd: [0, 200, 0], colorStart: [0, 0, 200], colorEnd: [0, 0, 100] },
    //     { colorStart: [130, 120, 0], colorEnd: [120, 0, 50], colorStart: [50, 60, 140], colorEnd: [140, 40, 240] },
    //     { colorStart: [230, 250, 30], colorEnd: [220, 140, 120], colorStart: [0, 130, 0], colorEnd: [150, 0, 120] },
    // ];
    // addColorPalette() {
    //     this.colorPalette = el('div.palette-list', [
    //         this.paletteList.map((palette) => {
    //             return el('div.palette-container', { onclick: () => { this.setPalette(palette) } }, [
    //                 el('div.picker-button', { style: { background: 'rgb(' + palette.colorStart[0] + ', ' + palette.colorStart[1] + ', ' + palette.colorStart[2] + ')' } }),
    //                 el('div.picker-button', { style: { background: 'rgb(' + palette.colorEnd[0] + ', ' + palette.colorEnd[1] + ', ' + palette.colorEnd[2] + ')' } }),
    //                 el('div.picker-button', { style: { background: 'rgb(' + palette.colorStart[0] + ', ' + palette.colorStart[1] + ', ' + palette.colorStart[2] + ')' } }),
    //                 el('div.picker-button', { style: { background: 'rgb(' + palette.colorEnd[0] + ', ' + palette.colorEnd[1] + ', ' + palette.colorEnd[2] + ')' } })
    //             ]);
    //         })
    //     ]);
    //     mount(document.body, this.colorPalette);

    //     window.addEventListener('click', (evt) => {
    //         if (evt.target == this.paletteButton.el) return;
    //         setStyle(this.colorPalette, { height: '0px' });
    //         this.paletteShown = false;
    //     });
    // }

    // setPalette(palette: paletteInterface) {
    //     this.resetInput({ colorStart: palette.colorStart, colorEnd: palette.colorEnd }, { colorStart: palette.colorStart, colorEnd: palette.colorEnd });
    //     this.environment.setBackStart(palette.colorStart);
    //     this.environment.setBackStop(palette.colorEnd);
    //     this.particle.setColorStart(palette.colorStart);
    //     this.particle.setColorEnd(palette.colorEnd);
    // }

    // paletteShown = false;
    // checkColorPalette() {
    //     if (this.paletteShown) {
    //         setStyle(this.colorPalette, { height: '0px' });
    //     } else {
    //         let height = this.paletteList.length * 70;
    //         setStyle(this.colorPalette, { height: height + 'px' });
    //         colorPicker.hidePicker();
    //     }
    //     this.paletteShown = !this.paletteShown;
    // }
}